import _ from 'underscore';
import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import { useRecommendation, useGoalwithParams } from '@bingads-webui-campaign-react/auto-goal-data-repository';

import { RecommendationTile } from './recommendation-tile';

export const RecommendationTileWithCondition = ({
  activity,
  i18n,
  isReadOnly,
  onClick,
  serverContext,
}) => {
  const [recommendation] = useRecommendation({ serverContext, activity });
  const formatDate = date => i18n.formatDate(date, { raw: 'M/d/yyyy' });
  const startDate = new Date();
  startDate.setFullYear(startDate.getFullYear() - 1);
  const params = {
    $filter: '(isAutoGoal eq true)', $startDate: formatDate(startDate), $endDate: formatDate(new Date()), $count: true,
  };
  const [, count] = useGoalwithParams({ serverContext, activity, params });
  const shouldShow = !_.isEmpty(recommendation) && count > 0;
  activity.trace(`[RecommendationTileWithCondition] should Show tile ${shouldShow} with auto goal count of ${count}`);

  const onClickInternal = (e) => {
    activity.trace('[RecommendationTileWithCondition] clicked');
    if (onClick) {
      onClick(e);
    }
  };

  return shouldShow ? <RecommendationTile onClick={onClickInternal} i18n={i18n} isReadOnly={isReadOnly} /> : <Fragment />;
};

RecommendationTileWithCondition.propTypes = {
  activity: PropTypes.shape({
    error: PropTypes.func,
    trace: PropTypes.func,
  }),
  i18n: PropTypes.shape({ getString: PropTypes.func }).isRequired,
  isReadOnly: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  serverContext: PropTypes.shape({
    CurrentAccount: PropTypes.shape({
      AdvertiserCustomerID: PropTypes.string,
      Id: PropTypes.string,
    }),
    Token: PropTypes.string,
  }).isRequired,
};

RecommendationTileWithCondition.defaultProps = {
  activity: { trace: _.noop, error: _.noop },
  isReadOnly: false,
};
